import { Content as DialogContent, Dialog, Title } from '../components/dialog/dialog';
import { Label, TextInputLarge } from '../components/forms/input';
import { Table } from '../components/table/table';
import { usePostMutation } from '../hooks/use-mutations';
import { HazardTypeLayer } from '../features/settings/hazard/types';
import { FieldValues, useForm } from 'react-hook-form';
import { Primary } from '../components/button/button';
import { Icons } from '../components/icons/icons';
import { FilteredLayer, LayerTypes } from '../features/geo-info/types/map-layer';

type Props = {
  type?: LayerTypes;
  title: string;
  onClose: () => void;
  selectedLayers: string[];
  onAdd: (layer: FilteredLayer) => void;
};

export const LayerFilter = (props: Props): JSX.Element => {
  const { register: registerLayer, handleSubmit, watch: watchSearchField } = useForm();
  const serviceSlug = watchSearchField('serviceSlug');
  const layerIdOrSlug = watchSearchField('layerIdOrSlug');
  const filterLayers = usePostMutation<HazardTypeLayer[]>({ path: '/map-layers/filter' });

  const onSubmit = (fields: FieldValues): void => {
    filterLayers.mutate(fields);
  };

  const getRows = (): HazardTypeLayer[] => {
    if (!filterLayers.data) {
      return [];
    }

    if (props.type) {
      return filterLayers.data.filter(item => item.type === props.type);
    }

    return filterLayers.data;
  };

  const columns = [
    { accessor: 'sharedId', Header: 'Shared Id', sort: true },
    { accessor: 'name', Header: 'Name', sort: true },
    { accessor: 'type', Header: 'Type', sort: true },
    { accessor: 'actions', Header: 'Add', Cell: (item: any): JSX.Element => {
        const row = item.row.original as HazardTypeLayer;
        if (props.selectedLayers.includes(row.id)) {
          return <div className="body-cell new-td disabled-color">
            <Icons.Add2 />
          </div>;
        }
        return <div className="body-cell new-td primary-color pointer" onClick={(): void => props.onAdd(row)}>
          <Icons.Add2 />
        </div>;
      } }
  ];

  return <Dialog onCancel={props.onClose} backdropClose={true} className="extra-large-dialog">
    <Title>{props.title}</Title>
    <DialogContent>
      <div className="mb-1">
        <Label name="slug">Filters:</Label>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-4 justify-content d-flex">
          <TextInputLarge {...registerLayer('serviceSlug')} placeholder="Service Slug" className="me-2" />
          <TextInputLarge {...registerLayer('layerIdOrSlug')} placeholder="Layer Id or Slug" className="ms-2 me-3"  />
          <Primary type="submit" disabled={filterLayers.isLoading || (!serviceSlug?.trim() && !layerIdOrSlug?.trim())}>Filter</Primary>
        </div>
      </form>
      <Table columns={columns} rows={getRows()} />
    </DialogContent>
  </Dialog>;
};
